export const mainNum = 5

export const START_TIME_WAREHOUSE = '2' // 放入仓库
export const EXPRESS_TEMPLATE_NUM = 0 // 表示按宝贝件数计算运费
export const EXPRESS_TEMPLATE_WEIGHT = 1 // 表示按宝贝重量计算运费
export const EXPRESS_TEMPLATE_SIZE = 3 // 表示按宝贝体积计算运费

export const TIME_SET_BY_SPU = '0' // 商品级设置(默认值为0)
export const TIME_SET_BY_SKU = '1' // 按SKU设置

export const MATERIAL_PROP_ID_REG = /^material_prop/

export const VERTICAL_IMAGE = 'verticalImage'

export const MAX_ITEMNO_LEN = 300 // 商家编码最大长度

// field id
export const FIELD_ID_SIZE_MAPPING = 'sizeMapping' // 商品尺寸表
export const FIELD_ID_SIZE_MODELTRY = 'size_model_try' // 尺码模特试穿表
export const FIELD_ID_SIZE_SELLERRECOMMEND = 'sizeSellerRecommend' // 商家建议尺码

export const FIELD_ID_SIZES = [FIELD_ID_SIZE_MAPPING, FIELD_ID_SIZE_MODELTRY, FIELD_ID_SIZE_SELLERRECOMMEND]

export const FIELD_ID_SKU = 'sku' // sku额外信息
export const FIELD_ID_BRAND = 'p-20000' // 品牌

// 标品匹配
export const SAMPLE_BRAND_ID = 'prop_20000' // 品牌
export const SAMPLE_DARWIN_SKU = 'darwin_sku' // 标品
export const SAMPLE_DARWIN_SALE_NAME = '产品规格' // 标品销售属性

// goodsSkuDetail 额外信息匹配 field
export const GOODS_SKU_DETAIL_BY_ID = [FIELD_ID_SKU, SAMPLE_DARWIN_SKU]

// sku 额外字段 有就显示
export const SKU_QUALITY = 'skuQuality' // sku  商品分类
export const SKU_QUALITY_MAINSKU = 'mainSku' // sku 分类 默认选中单品

export const SKU_PICTURE = 'skuPicture' // sku 图片
export const SKU_TITLE = 'skuTitle' // sku 标题
export const SKU_FIELD_IDS = [SKU_QUALITY]

export const SKU_QUALITY_VALIDATORS = [SKU_QUALITY_MAINSKU] // 需要校验的sku 分类 后台也是写死的

// sku 中不需要显示的
export const SKU_NORMAL_FIELD_IDS = [
    'props',
    'skuId',
    'skuPrice',
    'skuStock',
    'skuOuterId',
    'skuBarcode',
    'skuDeliveryTime',
    SKU_PICTURE, // 外部特殊处理
    SKU_TITLE, // 外部特殊处理
]

// sku 列额外参数
export const TAOBAO_SKU_PARAM = 'taoBaoSkuParam'

export const VALIDATE_FIELDS = ['price', 'quantity', 'itemNo']

// sku 参数
export const SKU_PARAM_BEGIN = 'skuParam_' // sku参数 前缀
export const TAOBAO_SKU_PARAM_DATA = 'taoBaoSkuParamData'

// 是否使用单选框
export const MAX_SINGLECHECK_LNE = 3

// 单位输入框
export const UNIT_INPUT_EXPRESSION = 'expression'
export const UNIT_INPUT_DATE = 'date'
export const UNIT_INPUT_DATERANGE = 'dateRange'

// 值失效了
export const VALUE_LOSE = 'lose'

/** 铺货模板 AI 打标字段（值与 templatePropId / aiFullItemId 一致，行尾为中文说明） */
export const SHELF_TEMPLATE_MAP = {
    ITEM_NAME: 'ITEM_NAME', // 标题-截取
    SKU_STOCK: 'SKU_STOCK', // 库存
    SKU_PRICE: 'SKU_PRICE', // 价格
    SHELVES_TYPE: 'SHELVES_TYPE', // 上架设置
}
